import { render } from "./BiotinidasePlasma.vue?vue&type=template&id=9aaf389e&scoped=true"
import script from "./BiotinidasePlasma.vue?vue&type=script&lang=js"
export * from "./BiotinidasePlasma.vue?vue&type=script&lang=js"

import "./BiotinidasePlasma.vue?vue&type=style&index=0&id=9aaf389e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aaf389e"]])

export default __exports__